export var CostRecordMetadataType;
(function (CostRecordMetadataType) {
    CostRecordMetadataType["DataTransfer"] = "DATA_TRANSFER";
    CostRecordMetadataType["Classification"] = "CLASSIFICATION";
})(CostRecordMetadataType || (CostRecordMetadataType = {}));
